// periods
import React, { useMemo } from 'react';
import { gql, useFragment, useReactiveVar } from '@apollo/client';
import { regionSubdivisionVar, selectedPeriodVar } from 'app/apollo/reaction';
import { getWeekByDate } from 'app/utils/weekByDate';
import { extraPeriodNYStart } from 'global/const/ny';

const SPECIFIC_UUD_DATES_FRAGMENT = gql`
fragment SPECIFIC_UUD_DATES_FRAGMENT on menuCalendar {
    subdivision
    dates {
        startDate
        eeAvailableDates
        everydayAvailableDates
        premiumAvailableDates
        topAvailableDates
    }
}`;

/**
 * @description читает данные конкретного периуда и cache
 */
export const useUDDData = (fragment = SPECIFIC_UUD_DATES_FRAGMENT) => {
    const regionSubdivision = useReactiveVar(regionSubdivisionVar);

    const regiodKey = useMemo(
        () => regionSubdivision?.replace(/_/, '-'),
        [regionSubdivision],
    );

    const { data } = useFragment({
        fragment,
        from: {
            __ref: `menuCalendar:{"subdivision":"${regiodKey}"}`,
        },
    });

    return data;
};
